"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const events_1 = require("events");
const LogTypes_1 = require("./LogTypes");
class Logger extends events_1.EventEmitter {
    constructor(logManager, logConfig) {
        super();
        this.compareLogLevel = (level) => (level <= this.logConfig.level) ? true : false;
        this.fatal = (message, error) => {
            this.log(LogTypes_1.LogLevels.FATAL, message, error);
        };
        this.error = (message, error) => {
            this.log(LogTypes_1.LogLevels.ERROR, message, error);
        };
        this.warn = (message, error) => {
            this.log(LogTypes_1.LogLevels.WARN, message, error);
        };
        this.info = (message, error) => {
            this.log(LogTypes_1.LogLevels.INFO, message, error);
        };
        this.debug = (message, error) => {
            this.log(LogTypes_1.LogLevels.DEBUG, message, error);
        };
        this.trace = (message, error) => {
            this.log(LogTypes_1.LogLevels.TRACE, message, error);
        };
        this.logManager = logManager;
        this.logConfig = logConfig;
    }
    prepareLogMessage(severityLevel, logMsg, error) {
        let stack = undefined;
        if (error instanceof Error) {
            stack = error.stack;
        }
        const newLogMsg = {
            message: logMsg,
            stack_trace: stack,
            agreement_number: this.logConfig.agreement_number,
            release: this.logConfig.release,
            timestamp: new Date().toISOString(),
            severity: LogTypes_1.LogLevels[severityLevel]
        };
        return newLogMsg;
    }
    log(logLevel, message, error) {
        if (this.compareLogLevel(logLevel)) {
            const logMessage = this.prepareLogMessage(logLevel, message, error);
            this.logManager.emit("log", logMessage);
        }
    }
}
exports.Logger = Logger;
